/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Describes a channel type for a task box
 * @export
 */
export const TaskChannelTypeEnum = {
    None: 'None',
    TwoPerson: 'TwoPerson',
    Results: 'Results'
} as const;
export type TaskChannelTypeEnum = typeof TaskChannelTypeEnum[keyof typeof TaskChannelTypeEnum];


export function instanceOfTaskChannelTypeEnum(value: any): boolean {
    for (const key in TaskChannelTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(TaskChannelTypeEnum, key)) {
            if (TaskChannelTypeEnum[key as keyof typeof TaskChannelTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TaskChannelTypeEnumFromJSON(json: any): TaskChannelTypeEnum {
    return TaskChannelTypeEnumFromJSONTyped(json, false);
}

export function TaskChannelTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskChannelTypeEnum {
    return json as TaskChannelTypeEnum;
}

export function TaskChannelTypeEnumToJSON(value?: TaskChannelTypeEnum | null): any {
    return value as any;
}

export function TaskChannelTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): TaskChannelTypeEnum {
    return value as TaskChannelTypeEnum;
}

